<template>
  <nav v-if="$vuetify.display.mobile">
    <message-dialog :dialog="moreMenuDisplayed" fullscreen hide-overlay disable-content-padding persistent>
      <template #header v-if="$vuetify.display.mobile">
        <header-mobile>
          <template #item-left>
            <h3 class="mobile-header-placeholder" />
          </template>
          <template #item-middle>
            <div class="d-flex justify-center flex-grow-1">
              <app-logo-wrapper />
            </div>
          </template>
          <template #item-right>
            <the-button v-if="isLoggedIn" :to="{ name: $routes.PROFILE_SETTINGS }" class="color-top-bar-text" icon custom-colors @click="onSettingsButtonClick">
              <i-custom-settings />
            </the-button>
          </template>
        </header-mobile>
      </template>
      <template #content>
        <custom-navigation v-if="moreMenuDisplayed" />
        <the-bottom-nav />
      </template>
    </message-dialog>
  </nav>
</template>

<script>
import { mapState, mapActions } from "pinia"

import { useAppStateStore } from "@/store/appState.js"
import { useUserSessionStore } from "@/store/userSession.js"
import { useConfigurationStore } from "@/store/configuration.js"

import CustomNavigation from "@/components/navs/CustomNavigation.vue"
import AppLogoWrapper from "@/components/navs/AppLogoWrapper.vue"

import { registerAnalyticsEvent } from "@/services/analytics.js"

export default {
  components: {
    CustomNavigation,
    AppLogoWrapper
  },
  data: () => ({}),
  computed: {
    ...mapState(useConfigurationStore, ["configuration"]),
    ...mapState(useUserSessionStore, ["isLoggedIn"]),
    ...mapState(useAppStateStore, ["moreMenuDisplayed"])
  },
  watch: {
    $route() {
      if (this.$vuetify.display.mobile) {
        this.setMoreMenuDisplayed(false)
      }
    },
    moreMenuDisplayed(val) {
      if (val) {
        this.registerInviteButtonMenuShownEvent()
      }
    }
  },
  methods: {
    ...mapActions(useAppStateStore, ["setMoreMenuDisplayed"]),
    registerInviteButtonMenuShownEvent() {
      if (!this.configuration.invitationLinkOnMoreMenu) {
        return
      }
      registerAnalyticsEvent({
        name: "invite-link-more-menu-item-impression"
      })
    },
    onSettingsButtonClick() {
      if (this.$route.name === this.$routes.PROFILE_SETTINGS) {
        this.setMoreMenuDisplayed(false)
      }
    }
  }
}
</script>
